import { ROLES_LIST } from '../constants/Roles';

function isGranted(role, user) {
  if (!user) {
    return false;
  }

  if (user.roles.includes('ROLE_SEO_EDITOR')) {
    return ['ROLE_USER', 'ROLE_SEO_EDITOR'].includes(role);
  }
  if (role === 'ROLE_SEO_EDITOR') return false;

  const roleIndex = ROLES_LIST.findIndex((e) => e === role);

  const initial = 0;
  const maxIndex = user.roles.reduce((accumulator, currentValue) => {
    const i = ROLES_LIST.findIndex((role) => role === currentValue);
    return i > accumulator ? i : accumulator;
  }, initial);

  return roleIndex <= maxIndex;
}

export { isGranted };
